<template>
    <div class="lc_wysiwygEditor TQ_center" >

        <div class="lc_toolbar TQ_direction_ltr" @mousedown="$event.preventDefault()">

            <img class="btn" title='Undo' :src="ass_img_undo" @click="execCommand_l('undo')" v-if="displayTopBar('undo')"/>
            <img class="btn" title='Redo' :src="ass_img_redo" @click="execCommand_l('redo')" v-if="displayTopBar('redo')"/>
            <div class="space"></div>

            <tq-pick-color class="TQ_inline" :p_prevent-default_b="true" p_system-lang-code_e="en" :pe_change-color_s="(color_s) => {execCommand_l('foreColor', color_s)}">
                <img :style="{'background': selectedForeColor}" class="btn" title='Text color' :src="ass_img_textColor" />
            </tq-pick-color>
            <tq-pick-color class="TQ_inline" :p_prevent-default_b="true" p_system-lang-code_e="en" :pe_change-color_s="(color_s) => {execCommand_l('hiliteColor', color_s)}">
                <img :style="{'background': selectedHiliteColor}" class="btn" title='Background color' :src="ass_img_marker" />
            </tq-pick-color>
            <!--<img :style="{'background': selectedForeColor}" class="btn" title='Text color' :src="ass_img_textColor" @click="$refs.foreColor.click()"/>-->
            <!--<input ref="foreColor" type="color"  name="head" v-show="false" @change="execCommand_l('foreColor', $event.target.value)">-->
            <!--<img :style="{'background': selectedHiliteColor}" class="btn" title='Background color' :src="ass_img_marker" @click="$refs.hiliteColor.click()"/>-->
            <!--<input ref="hiliteColor" type="color"  name="head" v-show="false" @change="execCommand_l('hiliteColor', $event.target.value)">-->
            <div class="space"></div>

            <img class="btn" title='Bold' :src="ass_img_letterB" @click="execCommand_l('bold')" :class="{'selected': selectedToolBar.bold}" v-if="displayTopBar('bold')"/>
            <img class="btn" title='Italic' :src="ass_img_letterI" @click="execCommand_l('italic')" :class="{'selected': selectedToolBar.italic}" v-if="displayTopBar('italic')"/>
            <img class="btn" title='Underline' :src="ass_img_underline" @click="execCommand_l('underline')" :class="{'selected': selectedToolBar.underline}" v-if="displayTopBar('underline')"/>
            <img class="btn" title='Strike Through' :src="ass_img_strikeThough" @click="execCommand_l('strikeThrough')" :class="{'selected': selectedToolBar.strikeThrough}" v-if="displayTopBar('strikeThrough')"/>
            <div class="space"></div>

            <img class="btn" title='Link' :src="ass_img_link" @click="execCommand_l('createLink')" :class="{'selected': selectedToolBar.createLink}"/>
            <img class="btn" title='Unlink' :src="ass_img_disconnectedLink" @click="execCommand_l('unLink')" :class="{'selected': selectedToolBar.unLink}"/>
            <div class="space"></div>

            <img class="btn" title='Align left' :src="ass_img_alignLeft" @click="execCommand_l('justifyLeft')" :class="{'selected': selectedToolBar.justifyLeft}"/>
            <img class="btn" title='Align Center' :src="ass_img_alignCenter" @click="execCommand_l('justifyCenter')" :class="{'selected': selectedToolBar.justifyCenter}"/>
            <img class="btn" title='Align Middle' :src="ass_img_alignRight" @click="execCommand_l('justifyRight')" :class="{'selected': selectedToolBar.justifyRight}"/>
            <img class="btn" title='Justify Full' :src="ass_img_alignJustify" @click="execCommand_l('justifyFull')" :class="{'selected': selectedToolBar.justifyFull}"/>
            <div class="space"></div>

            <img class="btn" title='Ordered List' :src="ass_img_numbering" @click="execCommand_l('insertOrderedList')" :class="{'selected': selectedToolBar.insertOrderedList}"/>
            <img class="btn" title='Unordere dList' :src="ass_img_bullets" @click="execCommand_l('insertUnorderedList')" :class="{'selected': selectedToolBar.insertUnorderedList}"/>
            <div class="space"></div>

            <tq-dropdown class="lc_dropdown TQ_verticalAlignMiddle">

                <div slot="select"
                     class="fonts select"
                     :style="{'font-family': selectedFont}"> {{selectedFont}} </div>

                <div   slot="options"
                       @click="execCommand_l('fontName', font)"
                       class="TQ_dropdown_option TQ_center TQ_padding_8px"
                       :style="{'font-family': font}"
                       :key="'font' + key"
                       v-for="(font,key) in fontsOptions">
                    {{font}}
                </div>

            </tq-dropdown>
            <tq-dropdown class="lc_dropdown  TQ_verticalAlignMiddle" :show-caret-down="false" :show-selected-border="true">

                <div slot="select" class="fontSize select"> {{selectedFontSize}} </div>

                <div    slot="options"
                        @click="execCommand_l('fontSize', fontSize)"
                        class="TQ_dropdown_option TQ_center TQ_padding_8px"
                        :key="'fontSize' + key"
                        :class="{'TQ_optionSelected': selectedFontSize === fontSize}"
                        v-for="(fontSize,key) in fontSizeOptions">
                    {{fontSize}}
                </div>
            </tq-dropdown>

            <div class="space"></div>

            <img class="btn imageBtn" title='Files' :src="ass_img_newFile_c"  @click="m_chooseFile_f" v-if="displayTopBar('addImage')"/>
            <div class="space"></div>

            <div class="btn TQ_inline TQ_text_14px TQ_text_bold" title='H1'  @click="execCommand_l('formatBlock', 'H1')" :class="{'selected': selectedToolBar.formatBlock}"> H1 </div>
            <div class="btn TQ_inline TQ_text_14px TQ_text_bold" title='H2'  @click="execCommand_l('formatBlock', 'H2')" :class="{'selected': selectedToolBar.formatBlock}"> H2 </div>
            <div class="btn TQ_inline TQ_text_14px TQ_text_bold" title='H3'  @click="execCommand_l('formatBlock', 'H3')" :class="{'selected': selectedToolBar.formatBlock}"> H3 </div>
            <div class="btn TQ_inline TQ_text_14px TQ_text_bold" title='H4'  @click="execCommand_l('formatBlock', 'H4')" :class="{'selected': selectedToolBar.formatBlock}"> H4 </div>
            <div class="space"></div>

            <img class="btn" title='Horizon Line' :src="ass_img_horizonLine" @click="execCommand_l('insertHorizontalRule')"/>
            <img class="btn" title='Clean' :src="ass_img_clean" @click="execCommand_l('removeFormat')" v-if="displayTopBar('removeFormat')"/>
            <div class="space"></div>

            <img class="btn" title='YouTube' :src="ass_img_videoPlayer" @click="execCommand_l('youtube')" v-if="displayTopBar('removeFormat')"/>

        </div>

        <div class="lc_resizeImage" v-if="showResizeImage">
            <div @click="updateImgStyle('width', '100%')"> 100% </div>
            <div @click="updateImgStyle('width', '50%')"> 50% </div>
            <div @click="updateImgStyle('width', '25%')"> 25% </div>
        </div>

        <div class="lc_editor">

            <div :id="fullId"
                 class="editorBody"
                 :style="{'height' : height}"
                 contenteditable="true"
                 ref="editorBody"
                 v-html="initValue_html"

                 @input="m_onBodyChange_f"
                 @keyup="refreshTopBarStatus"
                 @click="clickBody($event)"
                 @focus="m_dom_focus_f()"
                 @blur="m_dom_blur_f()">
            </div>

        </div>

    </div>
</template>

<script>
    import TqDropdown from "../basic/TqDropdown";
    import {
        ass_img_alignCenter, ass_img_alignJustify,
        ass_img_alignLeft, ass_img_alignRight, ass_img_bulletsList_b, ass_img_clean,
        ass_img_disconnectedLink, ass_img_horizonLine, ass_img_image,
        ass_img_letterB,
        ass_img_letterI, ass_img_link,
        ass_img_marker, ass_img_newFile_c, ass_img_numbering, ass_img_redo, ass_img_strikeThough,
        ass_img_textColor,
        ass_img_underline, ass_img_undo, ass_img_videoPlayer
    } from "@/assets/scripts/Ass_Files";
    import {gv_fonts} from "@/scripts/S_GlobalVar";
    import {enum_fileType} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqPickColor from "../basic2/TqPickColor";
    import TqPopup from "../basic/TqPopup";

    export default {
        name: "TqWysiwygEditor",
        components: {TqPopup, TqPickColor, TqDropdown},
        props: {
            p_value_html:{
                type: String,
                default : ""
            },
            reInit :{
                type: Number,
            },
            id :{
                type: String,
                default: "123"
            },
            height :{
                type: String,
                default: "400px"
            },
            topBarDontDisplay:{
                type: Array,
                default: () => {return []}
            },
            pe_chooseFile_f: {
                type: Function,
                require: true,
            },
            pe_updateValue_f:{
                type: Function,
                require: true
            }
        },
        data(){
            return{
                initValue_html: this.p_value_html,
                fullId :'editorTQ_' + this.id,
                startingBody: "",
                selectedToolBar: {},
                selectedFont: null,
                selectedForeColor: null,
                selectedHiliteColor: null,
                selectedFontSize : '3',

                fontSizeOptions: ['1','2', '3', '4', '5', '6', '7'],
                commands:[  'undo', 'redo', 'bold', 'italic', 'underline', 'underline', 'strikeThrough',
                            'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'createlink',
                            'unlink', 'insertOrderedList', 'insertUnorderedList'],

                showForeColors: false,
                showHighlighterColors: false,
                showFonts: false,
                showFontsSize: false,
                showResizeImage: false,
                selectedImgElement: {},

                resizeImageLocation: {
                    left: null,
                    right: null,
                    width: null
                },

                // assents
                fontsOptions: gv_fonts,


                ass_img_undo   : ass_img_undo,
                ass_img_redo   : ass_img_redo,

                ass_img_textColor   : ass_img_textColor,
                ass_img_marker      : ass_img_marker,

                ass_img_letterB     : ass_img_letterB,
                ass_img_letterI     : ass_img_letterI,
                ass_img_underline   : ass_img_underline,
                ass_img_strikeThough: ass_img_strikeThough,

                ass_img_link            : ass_img_link,
                ass_img_disconnectedLink: ass_img_disconnectedLink,

                ass_img_alignLeft   : ass_img_alignLeft,
                ass_img_alignCenter : ass_img_alignCenter,
                ass_img_alignRight  : ass_img_alignRight,
                ass_img_alignJustify: ass_img_alignJustify,

                ass_img_numbering   : ass_img_numbering,
                ass_img_bullets     : ass_img_bulletsList_b,

                ass_img_horizonLine : ass_img_horizonLine,
                ass_img_clean       : ass_img_clean,

                ass_img_image       : ass_img_image,
                ass_img_videoPlayer : ass_img_videoPlayer,
                ass_img_newFile_c : ass_img_newFile_c,
            }
        },
        methods: {

            m_chooseFile_f(){

                this.pe_chooseFile_f((file_c) =>{

                    switch (file_c.fi_type_e) {
                        case enum_fileType.video_mp4:
                            this.execCommand_l('video', file_c.fi_url_s)
                            break;
                        case enum_fileType.IMG_svg:
                        case enum_fileType.IMG_png:
                        case enum_fileType.IMG_jpeg:
                        case enum_fileType.IMG_gif:
                            this.execCommand_l('image', file_c.fi_url_s)
                            break;
                        case enum_fileType.audio_mp3:
                        case enum_fileType.audio_mpeg:
                        case enum_fileType.audio_ogg:
                            this.execCommand_l('audio', file_c.fi_url_s)
                            break;
                        default :
                            alert("Don't support file format")
                            console.log("Don't support file format", file_c)
                    }
                })
            },

            // set dom
            m_init_f() {

                this.selectedFont = this.fontsOptions[0]
                this.selectedFontSize = this.fontSizeOptions[2]

                // disable native image resizing on firefox
                document.execCommand('enableObjectResizing', false, 'false');


            },
            m_dom_focus_f(){},
            m_dom_blur_f(){},

            // callBack
            m_updateWysiwygBody_f(){

                let newBody = this.$refs.editorBody.innerHTML

                // add to the first line <div> ... </div>
                let word = '<div>'
                if(newBody.substring(0,word.length) != word){

                    let i
                    for(i=word.length; i < newBody.length; i++){
                        if(newBody.substring(i, i + word.length) == word){
                            break;
                        }
                    }
                    newBody = '<div>' + newBody.slice(0, i) + "</div>" + newBody.slice(i)
                }

                this.pe_updateValue_f(newBody)

            },

            // users events
            m_onBodyChange_f(evt) {

                // clean files
                this.cleanWysiwygFiles()

                // update wysiwyg body
                this.m_updateWysiwygBody_f();

                // refresh topbar
                this.refreshTopBarStatus()

            },
            clickBody(evt) {


                if (evt.target && evt.target.tagName && evt.target.tagName.toUpperCase() === 'IMG') {

                    if(this.selectedImgElement === evt.target){
                        this.showResizeImage = !this.showResizeImage
                        this.selectedImgElement = evt.target
                    }else {

                        this.showResizeImage = true
                        this.selectedImgElement = evt.target
                    }
                }else{
                    this.showResizeImage = false
                }

                this.refreshTopBarStatus()
            },

            // helpers
            execCommand_l(command, val) {
                // console.log(command, val)
                // console.log(window.getSelection().anchorNode)
                // console.log(window.getSelection().focusNode.nodeName)
                // console.log(window.getSelection().focusNode.nodeValue)
                // console.log(window.getSelection().focusNode.parentElement)

                if(!window.getSelection().focusNode){
                    return
                }

                if (window.getSelection().focusNode.parentElement.id === this.fullId) {
                    // console.log('newLine')
                }
                document.execCommand("styleWithCSS", true, null);

                // if not focus on the right element set focus on element
                if(this.$refs.editorBody != document.activeElement){
                    this.$refs.editorBody.focus()
                }

                if (command === '' || window.getSelection().focusNode == null) {
                    return
                }

                let insertHtml;
                let element;
                let div;

                switch (command) {

                    case 'image':
                        div = document.createElement("div");
                        element = document.createElement("IMG");
                        element.src = val
                        element.style.cursor = 'pointer'
                        element.style.width = '100%'
                        div.appendChild(element)
                        window.getSelection().focusNode.appendChild(div)
                        break;
                    case 'video':
                        div = document.createElement("div");
                        element = document.createElement("video");
                        element.style.width = '100%'
                        element.style.border = '1px solid black'
                        element.style.boxShadow = '0 2px 4px 0 rgba(0,0,0,0.2)'
                        element.style.borderRadius= '5px'
                        element.controls = true
                        element.src = val + "#t=0.00000001"
                        div.appendChild(element)
                        window.getSelection().focusNode.appendChild(div)
                        break;
                    case 'audio':
                        insertHtml =
                            '<audio controls style="width:100%" src="' + val + '">\n' +
                            'Your browser does not support the audio element.' +
                            '</audio>'
                        document.execCommand('insertHTML', false, insertHtml);

                        break;
                    case 'youtube':

                        console.log()

                        let youtubeLink = prompt('Enter the link here: ', 'http:\/\/')
                        if(youtubeLink) {
                            youtubeLink = youtubeLink.replace('watch', 'embed')
                            insertHtml = `<iframe width="100%" height="250"src="${youtubeLink}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`

                            document.execCommand('insertHTML', false, insertHtml);
                        }
                        break;
                    case 'direction':
                        if (this.elementPartOfEditor(window.getSelection().focusNode.parentElement)) {

                            document.execCommand('formatblock', false, 'p')
                            let selectedElement = window.getSelection().focusNode.parentElement
                            selectedElement.style[command] = val;
                        }
                        break;
                    case 'createLink':

                        let url = prompt('Enter the link here: ', 'http:\/\/')
                        if(url){
                            document.execCommand(command, false, url)
                            window.getSelection().focusNode.parentNode.target = "_blank"
                            window.getSelection().focusNode.parentNode.ref = "noopener noreferrer"
                        }

                        break;
                    // case 'underline':
                    //
                    //     let selectedElement = window.getSelection().focusNode.parentElement
                    //
                    //     if(selectedElement.style['text-decoration-line'] === 'underline'
                    //         || selectedElement.style['-webkit-text-decoration-line'] === 'underline'){
                    //         selectedElement.style['text-decoration-line'] = null;
                    //         selectedElement.style['-webkit-text-decoration-line'] = null;
                    //         selectedElement.style['text-decoration-color'] = null;
                    //         selectedElement.style['-webkit-text-decoration-color'] = null;
                    //     }else{
                    //         selectedElement.style['text-decoration-line'] = 'underline';
                    //         selectedElement.style['-webkit-text-decoration-line'] = 'underline';
                    //         selectedElement.style['text-decoration-color'] = 'black';
                    //         selectedElement.style['-webkit-text-decoration-color'] = 'black';
                    //     }
                    //     break;
                    // case 'fontSize':
                    //     selectedElement = window.getSelection().focusNode.parentElement
                    //     selectedElement.style['font-size'] = val
                    //     break;

                    default :
                        document.execCommand(command, false, val);
                }

                this.m_updateWysiwygBody_f();
                this.refreshTopBarStatus();

            },
            refreshTopBarStatus() {

                // check position
                let focusNode = window.getSelection().focusNode
                if (!focusNode || !this.elementPartOfEditor(window.getSelection().focusNode.parentElement)) {
                    return
                }

                // 1) best commands
                this.commands.forEach(cmd => {
                    this.$set(this.selectedToolBar, cmd, document.queryCommandState(cmd))
                })

                // 2) fontname
                let fontName = document.queryCommandValue('fontname')
                if (fontName[0] === "\"")
                    fontName = fontName.substring(1, fontName.length - 1)
                this.selectedFont = fontName

                let size = window.getComputedStyle(window.getSelection().focusNode.parentElement, null).getPropertyValue('font-size')

                let t = {
                    '10px' : 1,
                    '13px' : 2,
                    '16px' : 3,
                    '18px' : 4,
                    '24px' : 5,
                    '32px' : 6,
                    '48px' : 7,
                }
                if(size){
                    this.selectedFontSize = t[size]
                }else{
                    this.selectedFontSize = '3'
                }

                this.selectedForeColor = window.getSelection().focusNode.parentElement.style.color
                this.selectedHiliteColor = window.getSelection().focusNode.parentElement.style.backgroundColor

            },
            elementPartOfEditor(element) {
                while (element != null) {
                    if(element.id === this.fullId)
                        return true
                    element = element.parentElement
                }
                return false
            },

            // cleanWysiwygFiles
            cleanWysiwygFiles(){

                // todo : complete this function/ problem with ctrl z
                //
                // let cleanFiles_arr = []
                //
                // this.wysiwyg.w_files_ac.forEach(file =>{
                //
                //     let tokenIndex_n = file.fi_url_s.indexOf(enum_firebaseCloudUrlNames.token) //  = 0 => blobFile
                //     let token_s = file.fi_url_s.substring(tokenIndex_n)
                //
                //
                //     if(this.wysiwyg.w_body_s.includes(token_s)){
                //         cleanFiles_arr.push(file)
                //     }
                // })
                //
                // this.wysiwyg.w_files_ac = cleanFiles_arr
            },

            getId(url) {
                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                var match = url.match(regExp);

                if (match && match[2].length == 11) {
                    return match[2];
                } else {
                    return 'error';
                }
            },
            updateImgStyle(attName, val){
                this.selectedImgElement.style[attName] = val
                this.showResizeImage = false
                this.m_updateWysiwygBody_f();
            },
            displayTopBar(cmd){
                return this.topBarDontDisplay.indexOf(cmd) === -1
            },
            repositionResizeImage(){

                if(!this.showResizeImage)
                    return;

                const parent = this.$refs.editorBody
                const imgRect = this.selectedImgElement.getBoundingClientRect();
                const containerRect = parent.getBoundingClientRect();

                // left: `${imgRect.left - containerRect.left - 1 + parent.scrollLeft}px`,

                this.resizeImageLocation = {
                    top: `${imgRect.top - containerRect.top + parent.scrollTop}px`,
                    width: `${imgRect.width}px`,
                }


            },

        },
        watch:{
            reInit:{
                handler: function() {
                    this.m_init_f();
                },
                immediate: true
            }
        },
    }
</script>

<style scoped lang="scss">

    .lc_wysiwygEditor{
        background: white;
        width: 100%;

        .lc_toolbar{
            padding: 4px;
            text-align: center;
            border: 1px solid black;


            .btn{
                width: 16px;
                padding: 8px;
                border: 1px solid #AAA;
                background: #FFF;
                cursor: pointer;
                border-radius: 1px;
                color: black;
                -webkit-box-shadow: 0px 1px 0px #CCC;
                box-shadow: 0px 1px 0px #CCC;
                vertical-align: middle;
                margin: 4px 0px;

                &.imageBtn{
                    padding: 8px;
                }

                &:hover {
                    background: #f2f2f2;
                    border-color: #8c8c8c;
                }

                &.selected{
                    background: #F2F326;
                    border-color: #8c8c8c;
                }
            }

            .space{
                display: inline-block;
                width: 8px;
            }

            .lc_dropdown{

                border: 1px solid #AAA;
                background: #FFF;
                cursor: pointer;
                border-radius: 1px;
                color: black;
                -webkit-box-shadow: 0px 1px 0px #CCC;
                box-shadow: 0px 1px 0px #CCC;
                vertical-align: middle;
                max-height: 30px;

                .select{
                    width: 16px;
                    padding: 6px 8px;
                    &.fonts{
                        width: 170px;
                    }
                }
            }

        }

        .lc_resizeImage{
            /*position: relative;*/
            background: black;
            opacity: 0.7;
            display: inline-block;
            cursor: pointer;
            width: 100%;

            div{
                display: inline-block;
                padding: 8px;
                color: white;
                font-size: 16px;
                font-weight: bold;
            }
        }

        .lc_editor {
            overflow-y: auto;
            border: 1px solid black;
            box-shadow: 0 0 2px #CCC;
            overflow: auto;
            outline: none;
            padding:16px;


            .editorBody{
                &:focus {
                    outline: 0px solid transparent;
                }
            }
        }

}





</style>